// ----------------------------------------------------------------------

function path(root: string, sublink: string) {
  return `${root}${sublink}`;
}

type Id = number;

export const ROOTS_AUTH = '/auth';
export const ROOTS_DASHBOARD = '/dashboard';
export const ROOTS_DICTIONARIES = path(ROOTS_DASHBOARD, '/dictionaries');
export const ROOTS_PROCUREMENT = path(ROOTS_DASHBOARD, '/procurement');
export const ROOTS_GSHEETS = path(ROOTS_DASHBOARD, '/gsheets');
export const ROOTS_ADMINISTRATION = path(ROOTS_DASHBOARD, '/administration');
export const ROOTS_OZON = path(ROOTS_DASHBOARD, '/ozon');
export const ROOTS_WB = path(ROOTS_DASHBOARD, '/wb');
export const ROOTS_AVITO = path(ROOTS_DASHBOARD, '/avito');

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, '/login'),
};

export const PATH_PAGE = {
  comingSoon: '/coming-soon',
  maintenance: '/maintenance',
  page403: '/403',
  page404: '/404',
  page500: '/500',
  components: '/components',
};

export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/app'),
    checkPrice: {
      scroller: path(ROOTS_DASHBOARD, '/checkPrice'),
      new: path(ROOTS_DASHBOARD, '/checkPrice/new'),
      import: path(ROOTS_DASHBOARD, '/checkPrice/import'),
      view: (id: Id) => path(ROOTS_DASHBOARD, `/checkPrice/${id}`),
      edit: (id: Id) => path(ROOTS_DASHBOARD, `/checkPrice/${id}/edit`),
      newLink: (id: Id) => path(ROOTS_DASHBOARD, `/checkPrice/${id}/new`),
      viewLink: (id: Id, linkId: Id) => path(ROOTS_DASHBOARD, `/checkPrice/${id}/${linkId}`),
      editLink: (id: Id, linkId: Id) => path(ROOTS_DASHBOARD, `/checkPrice/${id}/${linkId}/edit`)
    },
    sites: {
      scroller: path(ROOTS_DASHBOARD, '/sites'),
      new: path(ROOTS_DASHBOARD, '/sites/new'),
      import: path(ROOTS_DASHBOARD, '/sites/import'),
      view: (id: number) => path(ROOTS_DASHBOARD, `/sites/${id}`),
      edit: (id: number) => path(ROOTS_DASHBOARD, `/sites/${id}/edit`),
      shop: {
        scroller: path(ROOTS_DASHBOARD, '/sites/:id/shop'),
        categories: {
          scroller: path(ROOTS_DASHBOARD, '/sites/:id/shop/categories'),
          new: path(ROOTS_DASHBOARD, '/sites/:id/shop/categories/new'),
          view: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/categories/${id}`),
          edit: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/categories/${id}/edit`)
        },
        products: {
          scroller: path(ROOTS_DASHBOARD, '/sites/:id/shop/products'),
          new: path(ROOTS_DASHBOARD, '/sites/:id/shop/products/new'),
          view: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/products/${id}`),
          edit: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/products/${id}/edit`)
        },
        payment: {
          scroller: path(ROOTS_DASHBOARD, '/sites/:id/shop/payment'),
          new: path(ROOTS_DASHBOARD, '/sites/:id/shop/payment/new'),
          view: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/payment/${id}`),
          edit: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/payment/${id}/edit`)
        },
        delivery: {
          scroller: path(ROOTS_DASHBOARD, '/sites/:id/shop/delivery'),
          new: path(ROOTS_DASHBOARD, '/sites/:id/shop/delivery/new'),
          view: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/delivery/${id}`),
          edit: (id: number, params?: Record<string, any>) =>
            path(ROOTS_DASHBOARD, `/sites/${params?.id}/shop/delivery/${id}/edit`)
        }
      },
      news: {
        scroller: path(ROOTS_DASHBOARD, '/sites/:id/news'),
        new: path(ROOTS_DASHBOARD, '/sites/:id/news/new'),
        view: (id: number, params?: Record<string, any>) => path(ROOTS_DASHBOARD, `/sites/${params?.id}/news/${id}`),
        edit: (id: number, params?: Record<string, any>) =>
          path(ROOTS_DASHBOARD, `/sites/${params?.id}/news/${id}/edit`)
      },
      pages: {
        scroller: path(ROOTS_DASHBOARD, '/sites/:id/pages'),
        new: path(ROOTS_DASHBOARD, '/sites/:id/pages/new'),
        view: (id: number, params?: Record<string, any>) => path(ROOTS_DASHBOARD, `/sites/${params?.id}/pages/${id}`),
        edit: (id: number, params?: Record<string, any>) =>
          path(ROOTS_DASHBOARD, `/sites/${params?.id}/pages/${id}/edit`)
      }
    }
  },
  procurement: {
    root: ROOTS_PROCUREMENT,
    suppliers: {
      scroller: path(ROOTS_PROCUREMENT, '/suppliers'),
      new: path(ROOTS_PROCUREMENT, '/suppliers/new'),
      view: (id: Id) => path(ROOTS_PROCUREMENT, `/suppliers/${id}`),
      edit: (id: Id) => path(ROOTS_PROCUREMENT, `/suppliers/${id}/edit`)
    },
    contracts: {
      scroller: path(ROOTS_PROCUREMENT, '/contracts'),
      new: path(ROOTS_PROCUREMENT, '/contracts/new'),
      view: (id: Id) => path(ROOTS_PROCUREMENT, `/contracts/${id}`),
      edit: (id: Id) => path(ROOTS_PROCUREMENT, `/contracts/${id}/edit`)
    },
    requests: {
      scroller: path(ROOTS_PROCUREMENT, '/requests'),
      new: path(ROOTS_PROCUREMENT, '/requests/new'),
      view: (id: Id) => path(ROOTS_PROCUREMENT, `/requests/${id}`),
      edit: (id: Id) => path(ROOTS_PROCUREMENT, `/requests/${id}/edit`)
    },
    deliveries: {
      scroller: path(ROOTS_PROCUREMENT, '/deliveries'),
      new: path(ROOTS_PROCUREMENT, '/deliveries/new'),
      view: (id: Id) => path(ROOTS_PROCUREMENT, `/deliveries/${id}`),
      edit: (id: Id) => path(ROOTS_PROCUREMENT, `/deliveries/${id}/edit`)
    }
  },
  user: {
    account: path(ROOTS_DASHBOARD, '/user/account')
  },
  dictionaries: {
    root: ROOTS_DICTIONARIES,
    product: {
      scroller: path(ROOTS_DICTIONARIES, '/product'),
      new: path(ROOTS_DICTIONARIES, '/product/new'),
      import: path(ROOTS_DICTIONARIES, '/product/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/product/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/product/${id}/edit`)
    },
    storages: {
      scroller: path(ROOTS_DICTIONARIES, '/storages'),
      new: path(ROOTS_DICTIONARIES, '/storages/new'),
      import: path(ROOTS_DICTIONARIES, '/storages/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/storages/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/storages/${id}/edit`)
    },
    accounts: {
      scroller: path(ROOTS_DICTIONARIES, '/accounts'),
      new: path(ROOTS_DICTIONARIES, '/accounts/new'),
      import: path(ROOTS_DICTIONARIES, '/accounts/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/accounts/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/accounts/${id}/edit`)
    },
    transactionArticles: {
      scroller: path(ROOTS_DICTIONARIES, '/transaction-articles'),
      new: path(ROOTS_DICTIONARIES, '/transaction-articles/new'),
      import: path(ROOTS_DICTIONARIES, '/transaction-articles/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/transaction-articles/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/transaction-articles/${id}/edit`)
    },
    sourceOrders: {
      scroller: path(ROOTS_DICTIONARIES, '/source-orders'),
      new: path(ROOTS_DICTIONARIES, '/source-orders/new'),
      import: path(ROOTS_DICTIONARIES, '/source-orders/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/source-orders/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/source-orders/${id}/edit`)
    },
    deliveryServices: {
      scroller: path(ROOTS_DICTIONARIES, '/delivery-services'),
      new: path(ROOTS_DICTIONARIES, '/delivery-services/new'),
      import: path(ROOTS_DICTIONARIES, '/delivery-services/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/delivery-services/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/delivery-services/${id}/edit`)
    },
    documentTemplates: {
      scroller: path(ROOTS_DICTIONARIES, '/document-templates'),
      new: path(ROOTS_DICTIONARIES, '/document-templates/new'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/document-templates/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/document-templates/${id}/edit`)
    },
    category: {
      scroller: path(ROOTS_DICTIONARIES, '/category'),
      new: path(ROOTS_DICTIONARIES, '/category/new'),
      import: path(ROOTS_DICTIONARIES, '/category/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/category/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/category/${id}/edit`)
    },
    brand: {
      scroller: path(ROOTS_DICTIONARIES, '/brand'),
      new: path(ROOTS_DICTIONARIES, '/brand/new'),
      import: path(ROOTS_DICTIONARIES, '/brand/import'),
      view: (id: Id) => path(ROOTS_DICTIONARIES, `/brand/${id}`),
      edit: (id: Id) => path(ROOTS_DICTIONARIES, `/brand/${id}/edit`)
    }
  },
  administration: {
    root: ROOTS_ADMINISTRATION,
    user: {
      scroller: path(ROOTS_ADMINISTRATION, '/user'),
      new: path(ROOTS_ADMINISTRATION, '/user/new'),
      view: (id: Id) => path(ROOTS_ADMINISTRATION, `/user/${id}`)
    },
    groups: {
      scroller: path(ROOTS_ADMINISTRATION, '/groups'),
      new: path(ROOTS_ADMINISTRATION, '/groups/new'),
      import: path(ROOTS_ADMINISTRATION, '/groups/import'),
      view: (id: Id) => path(ROOTS_ADMINISTRATION, `/groups/${id}`),
      edit: (id: Id) => path(ROOTS_ADMINISTRATION, `/groups/${id}/edit`),
    },
    i18nLang: {
      scroller: path(ROOTS_ADMINISTRATION, '/i18nlang'),
      new: path(ROOTS_ADMINISTRATION, '/i18nlang/new'),
      import: path(ROOTS_ADMINISTRATION, '/i18nlang/import'),
      view: (id: Id) => path(ROOTS_ADMINISTRATION, `/i18nlang/${id}`),
      edit: (id: Id) => path(ROOTS_ADMINISTRATION, `/i18nlang/${id}/edit`)
    },
    i18nKeys: {
      scroller: path(ROOTS_ADMINISTRATION, '/translations'),
      new: path(ROOTS_ADMINISTRATION, '/translations/new'),
      view: (id: Id) => path(ROOTS_ADMINISTRATION, `/translations/${id}`),
      edit: (id: Id) => path(ROOTS_ADMINISTRATION, `/translations/${id}/edit`)
    }
  },
  storageDocuments: {
    scroller: path(ROOTS_DASHBOARD, '/storageDocuments'),
    new: path(ROOTS_DASHBOARD, '/storageDocuments/new'),
    import: path(ROOTS_DASHBOARD, '/storageDocuments/import'),
    view: (id: Id) => path(ROOTS_DASHBOARD, `/storageDocuments/${id}`),
    edit: (id: Id) => path(ROOTS_DASHBOARD, `/storageDocuments/${id}/edit`)
  },
  transactions: {
    scroller: path(ROOTS_DASHBOARD, '/transactions'),
    new: path(ROOTS_DASHBOARD, '/transactions/new'),
    import: path(ROOTS_DASHBOARD, '/transactions/import'),
    view: (id: Id) => path(ROOTS_DASHBOARD, `/transactions/${id}`),
    edit: (id: Id) => path(ROOTS_DASHBOARD, `/transactions/${id}/edit`)
  },
  storageShipments: {
    scroller: path(ROOTS_DASHBOARD, '/storageShipments'),
    new: path(ROOTS_DASHBOARD, '/storageShipments/new'),
    view: (id: Id) => path(ROOTS_DASHBOARD, `/storageShipments/${id}`),
    edit: (id: Id) => path(ROOTS_DASHBOARD, `/storageShipments/${id}/edit`)
  },
  sales: {
    scroller: path(ROOTS_DASHBOARD, '/sales'),
    new: path(ROOTS_DASHBOARD, '/sales/new'),
    view: (id: Id) => path(ROOTS_DASHBOARD, `/sales/${id}`),
    edit: (id: Id) => path(ROOTS_DASHBOARD, `/sales/${id}/edit`)
  },
  ozon: {
    root: ROOTS_OZON,
    sellerAccounts: {
      scroller: path(ROOTS_OZON, '/seller-accounts'),
      new: path(ROOTS_OZON, '/seller-accounts/new'),
      view: (id: Id) => path(ROOTS_OZON, `/seller-accounts/${id}`),
      edit: (id: Id) => path(ROOTS_OZON, `/seller-accounts/${id}/edit`)
    },
    postings: {
      scroller: path(ROOTS_OZON, '/postings'),
      new: path(ROOTS_OZON, '/postings/new'),
      view: (id: Id) => path(ROOTS_OZON, `/postings/${id}`),
      edit: (id: Id) => path(ROOTS_OZON, `/postings/${id}/edit`)
    }
  },
  wb: {
    root: ROOTS_WB,
    sellerAccounts: {
      scroller: path(ROOTS_WB, '/seller-accounts'),
      new: path(ROOTS_WB, '/seller-accounts/new'),
      view: (id: Id) => path(ROOTS_WB, `/seller-accounts/${id}`),
      edit: (id: Id) => path(ROOTS_WB, `/seller-accounts/${id}/edit`)
    },
    postings: {
      scroller: path(ROOTS_WB, '/postings'),
      new: path(ROOTS_WB, '/postings/new'),
      view: (id: Id) => path(ROOTS_WB, `/postings/${id}`),
      edit: (id: Id) => path(ROOTS_WB, `/postings/${id}/edit`)
    },
    catalogProducts: {
      scroller: path(ROOTS_WB, '/catalog-products'),
      new: path(ROOTS_WB, '/catalog-products/new'),
      view: (id: Id) => path(ROOTS_WB, `/catalog-products/${id}`),
      edit: (id: Id) => path(ROOTS_WB, `/catalog-products/${id}/edit`)
    }
  },
  avito: {
    root: ROOTS_AVITO,
    sellerAccounts: {
      scroller: path(ROOTS_AVITO, '/seller-accounts'),
      new: path(ROOTS_AVITO, '/seller-accounts/new'),
      view: (id: Id) => path(ROOTS_AVITO, `/seller-accounts/${id}`),
      edit: (id: Id) => path(ROOTS_AVITO, `/seller-accounts/${id}/edit`)
    },
    postings: {
      scroller: path(ROOTS_AVITO, '/postings'),
      new: path(ROOTS_AVITO, '/postings/new'),
      view: (id: Id) => path(ROOTS_AVITO, `/postings/${id}`),
      edit: (id: Id) => path(ROOTS_AVITO, `/postings/${id}/edit`)
    }
  }
};

export const SCROLLERS_PATHS = [
  PATH_DASHBOARD.dictionaries.product.scroller,
  PATH_DASHBOARD.dictionaries.storages.scroller,
  PATH_DASHBOARD.dictionaries.accounts.scroller,
  PATH_DASHBOARD.dictionaries.transactionArticles.scroller,
  PATH_DASHBOARD.dictionaries.sourceOrders.scroller,
  PATH_DASHBOARD.dictionaries.deliveryServices.scroller,
  PATH_DASHBOARD.dictionaries.documentTemplates.scroller,
  PATH_DASHBOARD.dictionaries.category.scroller,
  PATH_DASHBOARD.dictionaries.brand.scroller,
  PATH_DASHBOARD.administration.user.scroller,
  PATH_DASHBOARD.administration.groups.scroller,
  PATH_DASHBOARD.administration.i18nLang.scroller,
  PATH_DASHBOARD.administration.i18nKeys.scroller,
  PATH_DASHBOARD.storageDocuments.scroller,
  PATH_DASHBOARD.transactions.scroller,
  PATH_DASHBOARD.storageShipments.scroller,
  PATH_DASHBOARD.sales.scroller,
  PATH_DASHBOARD.ozon.sellerAccounts.scroller,
  PATH_DASHBOARD.ozon.postings.scroller,
  PATH_DASHBOARD.wb.sellerAccounts.scroller,
  PATH_DASHBOARD.wb.postings.scroller,
  PATH_DASHBOARD.wb.catalogProducts.scroller,
  PATH_DASHBOARD.avito.sellerAccounts.scroller,
  PATH_DASHBOARD.avito.postings.scroller,
  PATH_DASHBOARD.procurement.suppliers.scroller,
  PATH_DASHBOARD.procurement.requests.scroller,
  PATH_DASHBOARD.procurement.contracts.scroller,
  PATH_DASHBOARD.procurement.deliveries.scroller,
  PATH_DASHBOARD.general.checkPrice.scroller,
  PATH_DASHBOARD.general.sites.scroller,
  PATH_DASHBOARD.general.sites.news.scroller,
  PATH_DASHBOARD.general.sites.pages.scroller,
  PATH_DASHBOARD.general.sites.shop.categories.scroller,
  PATH_DASHBOARD.general.sites.shop.products.scroller,
  PATH_DASHBOARD.general.sites.shop.payment.scroller,
  PATH_DASHBOARD.general.sites.shop.delivery.scroller,
];

export const PATH_DOCS = {
  root: 'https://docs.minimals.cc',
  changelog: 'https://docs.minimals.cc/changelog',
};
